import { formatDuration, type Locale } from 'date-fns';

/** "1 hr", "1 hr 30 min", "45 min". */
const formatMinutes = (minutes: number, locale?: Locale): string => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  // date-fns writes the units in the guest's language — "1 h 30 min", "1 Std. 30 Min.", "1 時間 30 分".
  return formatDuration(
    { ...(hours ? { hours } : {}), ...(rest ? { minutes: rest } : {}) },
    { format: ['hours', 'minutes'], locale },
  );
};

export default formatMinutes;
